import { render, staticRenderFns } from "./UploadRefTray.vue?vue&type=template&id=798e5c24&scoped=true"
import script from "./UploadRefTray.vue?vue&type=script&lang=js"
export * from "./UploadRefTray.vue?vue&type=script&lang=js"
import style0 from "./UploadRefTray.vue?vue&type=style&index=0&id=798e5c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e5c24",
  null
  
)

export default component.exports